import { Marker, Tooltip } from 'react-leaflet';
import { capitalizeWord } from 'utils/strings/string.utils';
import WeatherMapDetailsPopup from '../../../../../../components/WeatherMapDetailsPopup/WeatherMapDetailsPopup';
import {
  hurricaneDetailGroups,
  hurricaneDetails,
} from '../../../../config/hurricaneDetails.config';
import { HURRICANES_STORM_POSITION_ICONS } from '../../../../config/hurricanes.config';

const getPositionLabel = ({ isActive, isDefaultView, isForecast }) => {
  if (!isActive) return isForecast ? 'Forecast position' : 'Observed position';
  if (!isDefaultView) return isForecast ? 'Active forecast position' : 'Active observed position';
  return isForecast ? 'Latest forecast position' : 'Latest observed position';
};

const getPositionIcon = ({ isActive, isForecast }) => {
  if (isActive) {
    return isForecast
      ? HURRICANES_STORM_POSITION_ICONS.activeForecast
      : HURRICANES_STORM_POSITION_ICONS.activeObserved;
  }

  return isForecast
    ? HURRICANES_STORM_POSITION_ICONS.forecast
    : HURRICANES_STORM_POSITION_ICONS.observed;
};

const StormPositionMarker = ({ group, marker, isDefaultView }) => {
  const { key, position, isActive, isForecast, record } = marker;
  const stormName =
    record.local_storm_name || record.name || group.localName || group.name || 'Storm';
  const positionLabel = getPositionLabel({ isActive, isDefaultView, isForecast });
  const accessibleLabel = [stormName, positionLabel, record.locale_time].filter(Boolean).join(', ');

  return (
    <Marker
      key={key}
      position={position}
      icon={getPositionIcon({ isActive, isForecast })}
      alt={accessibleLabel}
      title={accessibleLabel}
      keyboard={isActive}
      riseOnHover
      zIndexOffset={isActive ? 1000 : 0}
    >
      {isActive && !isDefaultView && (
        <Tooltip
          className="hurricane-active-position-label"
          direction="top"
          offset={[0, -2]}
          opacity={1}
          permanent
        >
          <span className="d-flex flex-column lh-sm text-center">
            <strong>{stormName}</strong>
            {isForecast && <small>Forecast position</small>}
          </span>
        </Tooltip>
      )}

      <WeatherMapDetailsPopup
        eyebrow={positionLabel}
        title={stormName}
        subtitle={capitalizeWord(record.type ?? '')}
        meta={record.locale_time}
        selectedItem={record}
        details={hurricaneDetails}
        layoutGroups={hurricaneDetailGroups}
        detailsClassName="hurricanes-map-popup-details"
        ariaLabel={`${positionLabel} details for ${stormName}`}
      />
    </Marker>
  );
};

export default StormPositionMarker;
